import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/ic-upload.svg'


const _hoisted_1 = {
  class: "page__header",
  style: {"margin-top":"5rem","margin-bottom":"0"}
}
const _hoisted_2 = {
  class: "page__row",
  style: {"width":"40%","margin-right":"2rem"}
}
const _hoisted_3 = { style: {"margin-left":"auto","display":"flex","column-gap":"15px","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "registry-upload__help" }, "Загрузка пользователей", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Таблица доступов")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "page__stats",
  style: {"margin-bottom":"1rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "page__header-title",
    style: {"margin-bottom":"1rem"}
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiMultiSelector = _resolveComponent("UiMultiSelector")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_UiTable = _resolveComponent("UiTable")!
  const _component_ViewportObserver = _resolveComponent("ViewportObserver")!
  const _component_UploadNewUsers = _resolveComponent("UploadNewUsers")!
  const _component_ModalConfirmUserChanges = _resolveComponent("ModalConfirmUserChanges")!
  const _component_ModalEditUser = _resolveComponent("ModalEditUser")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UiInput, {
            label: "Имя сотрудника",
            placeholder: "Введите",
            style: {"flex":"1 0 auto","font-size":"15px"},
            modelValue: _ctx.users.filters.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.filters.name) = $event)),
            search: ""
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_UiMultiSelector, {
          class: "access-control_table",
          style: {"width":"400px"},
          placeholder: "Выбрать роль",
          options: { data: _ctx.roles.options, closeOnSelect: false },
          modelValue: _ctx.users.filters.role,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.users.filters.role) = $event))
        }, null, 8, ["options", "modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: "registry-upload",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadNewItems = true))
          }, _hoisted_6),
          _createVNode(_component_Btn, {
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'roles-table' })))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_8,
      _createVNode(_component_UiTable, {
        class: "access-control_table",
        "onChange:role": _ctx.changeRole,
        "onChange:ugns": _ctx.requestToChangeUgnsHandler,
        onRemoveUser: _ctx.requestToRemoveUserHandler,
        onEditUser: _ctx.editUserHandler,
        cols: _ctx.cols,
        rows: _ctx.users.rows,
        "empty-banner-text": _ctx.users.fetching ? 'Идет загрузка' : 'Нет данных'
      }, null, 8, ["onChange:role", "onChange:ugns", "onRemoveUser", "onEditUser", "cols", "rows", "empty-banner-text"]),
      (_ctx.users.showLoader)
        ? (_openBlock(), _createBlock(_component_ViewportObserver, {
            key: 0,
            onShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.users.fetchNextPage()))
          }))
        : _createCommentVNode("", true),
      (_ctx.showUploadNewItems)
        ? (_openBlock(), _createBlock(_component_UploadNewUsers, {
            key: 1,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showUploadNewItems = false))
          }))
        : _createCommentVNode("", true),
      (_ctx.modalInspectorManager.display)
        ? (_openBlock(), _createBlock(_component_ModalConfirmUserChanges, {
            key: 2,
            data: _ctx.modalInspectorManager,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalInspectorManager.display = _ctx.modalInspectorManager.hasObjectsToTransfer = false)),
            "onUpdate:transferId": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalInspectorManager.inspectors.transferId = $event)),
            onUserChangesConfirmed: _ctx.usersChangesConfirmedHandler
          }, null, 8, ["data", "onUserChangesConfirmed"]))
        : _createCommentVNode("", true),
      (_ctx.editInspectorManager.display)
        ? (_openBlock(), _createBlock(_component_ModalEditUser, {
            key: 3,
            modelValue: _ctx.editInspectorManager.data,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editInspectorManager.data) = $event)),
            inspector: _ctx.editInspectorManager,
            onEditUserConfirmed: _ctx.editUserConfirmed,
            onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editInspectorManager.display = false))
          }, null, 8, ["modelValue", "inspector", "onEditUserConfirmed"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}